<template>
  <nav class="navbar d-flex justify-content-around navbar-footer">
    <router-link
      class="flex-fill flex-column d-flex text-center"
      tag="a"
      :to="{ name: 'home' }"
    >
      <i class="fa fa-home ic"></i>
      <span>首页</span>
    </router-link>
    <router-link
      class="flex-fill flex-column d-flex text-center"
      tag="a"
      :to="{ name: 'dynamic' }"
    >
      <i class="fa fa-bell ic"></i>
      <span>消息</span>
    </router-link>

    <router-link
      v-if="!hideEntry"
      class="flex-fill flex-column d-flex text-center"
      tag="a"
      :to="{ name: 'enter' }"
    >
      <i class="fa fa-font-awesome ic"></i>
      <span>入驻</span>
    </router-link>

    <router-link
      v-if="!hidePerson"
      class="flex-fill flex-column d-flex text-center"
      tag="a"
      :to="{ name: 'auth-personal' }"
    >
      <i class="fa fa-user ic"></i>
      <span>个人中心</span>
    </router-link>
  </nav>
</template>
<script>
export default {
  name: "navbar-footer",
  props: ["useCompany_props"],
  data() {
    return {
      hideList: ["ywglg"],
      useCompany: sessionStorage.getItem("useCompany")
    };
  },
  create() {
    this.useCompany = this.useCompany_props || this.useCompany;
  },
  computed: {
    hideEntry() {
      return this.hideList.includes(this.useCompany);
    },
    hidePerson() {
      return this.hideList.includes(this.useCompany);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./navbar-footer";
</style>
